import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, Modal, Row, Select, message, Input, Spin } from "antd";

const { TextArea } = Input;
const { Option } = Select;

interface AssignFeatureProps {
  selectedRowKey: string | null;
  selectedBookingData?: any;
  onCancelConfirm?: (rowKey: string, values: any) => void;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  confirmLoading?: boolean;
}

const CancelModel: React.FC<AssignFeatureProps> = ({
  selectedRowKey,
  selectedBookingData,
  onCancelConfirm,
  isOpen,
  onOpenChange,
  confirmLoading,
}) => {
  const [localOpen, setLocalOpen] = useState(false);
  const open = typeof isOpen === "boolean" ? isOpen : localOpen;
  const setOpen = typeof onOpenChange === "function" ? onOpenChange : setLocalOpen;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { cancelReasons, cancelReasonsLoading } = useSelector(
    (state: any) => state.newBooking || {}
  );

  const CANCEL_REASONS = [
    "No Cab-T",
    "Got Another -C",
    "Heavy and Long-C",
    "Not Ready-C",
    "Tele Cancel",
    "Due to Rain-C",
    "Delay-D",
    "No Reply-D",
    "No Reply-C",
    "Plan Change-C",
    "Not taken-D",
    "Vehicle Problem",
    "Post Assign-T",
  ];

  useEffect(() => {
    if (open) {
      form.resetFields();
      const bookingId =
        selectedBookingData?.id ||
        selectedBookingData?.BookId ||
        selectedBookingData?.bookid ||
        selectedBookingData?.bookingId ||
        selectedBookingData?._id ||
        selectedRowKey ||
        "";
      const cabId =
        selectedBookingData?.cabid ||
        selectedBookingData?.cabId ||
        selectedBookingData?.cabno ||
        selectedBookingData?.vehicleid ||
        "";

      form.setFieldsValue({
        bookingId,
        cabId,
        reason: undefined,
        remarks: "",
      });
    } else {
      form.resetFields();
    }
  }, [open, selectedBookingData, selectedRowKey, form]);

  useEffect(() => {
    //console.log("[CancelModel] cancelReasons from Redux:", cancelReasons);
  }, [cancelReasons]);

  const handleAssignClick = () => {
    if (!selectedRowKey) {
      message.warning("Please select a row first");
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    form.resetFields();
  };

  const handlecancel = () => {
    form.validateFields().then((values) => {
      if (selectedRowKey && onCancelConfirm) {
        onCancelConfirm(selectedRowKey, values);
      }
    }).catch((info) => {
      //console.log('Validate Failed:', info);
    });
  };

  return (
    <>
      <Button className="action-btn1 secondary" onClick={handleAssignClick} disabled={!selectedRowKey}>
        Cancel
      </Button>

      <Modal
        title="Cancel Booking"
        open={open}
        centered
        closable={false}
        destroyOnClose={true}
        width={{ xs: "94vw", md: 650 }}
        footer={
          <Row justify="center" style={{ gap: "16px", marginTop: "24px" }}>
            <Button
              type="default"
              size="large"
              style={{ minWidth: 140, borderRadius: 8, fontWeight: 500 }}
              onClick={handleClose}
              disabled={confirmLoading}
            >
              Close
            </Button>
            <Button
              type="primary"
              size="large"
              danger
              onClick={handlecancel}
              loading={confirmLoading}
              style={{
                minWidth: 140,
                borderRadius: 8,
                fontWeight: 600,
                boxShadow: "0 4px 12px rgba(255, 77, 109, 0.3)"
              }}
            >
              Confirm Cancel
            </Button>
          </Row>
        }
        styles={{
          header: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            background: "linear-gradient(135deg, #ff4d6d, #ff758f)",
            color: "#ffffff",
            borderBottom: "none",
            padding: "20px 24px",
            textAlign: "center",
          },
          title: {
            color: "#ffffff",
            fontSize: 22,
            fontWeight: 700,
            letterSpacing: "0.5px",
            margin: 0,
          },
          body: { paddingTop: 24, paddingBottom: 0, paddingLeft: 32, paddingRight: 32 },
        }}
        modalRender={(modal) => (
          <div style={{ borderRadius: 16, overflow: "hidden" }}>{modal}</div>
        )}
      >
        <Spin spinning={!!confirmLoading} tip="Canceling booking...">
          <Form form={form} layout="vertical">
            <Row gutter={[24, 16]}>
              <Col span={12}>
                <Form.Item
                  label={<span style={{ fontWeight: 600, color: "#444" }}>Booking ID</span>}
                  name="bookingId"
                  rules={[{ required: true, message: "Enter booking ID" }]}
                >
                  <Input size="large" placeholder="Enter booking id" style={{ borderRadius: 8, height: 46 }} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={<span style={{ fontWeight: 600, color: "#444" }}>Cab ID</span>}
                  name="cabId"
                //rules={[{ required: true, message: "Enter Cab ID" }]}
                >
                  <Input size="large" placeholder="Enter Cab ID" style={{ borderRadius: 8, height: 46 }} />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label={<span style={{ fontWeight: 600, color: "#444" }}>Reason</span>}
                  name="reason"
                  rules={[{ required: true, message: "Please select reason" }]}
                >
                  <Select
                    size="large"
                    placeholder="Select cancel reason"
                    style={{ borderRadius: 8, height: 46 }}
                    showSearch
                    optionFilterProp="children"
                  >
                    {CANCEL_REASONS.map((reason) => (
                      <Option key={reason} value={reason}>
                        {reason}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label={<span style={{ fontWeight: 600, color: "#444" }}>Remarks</span>}
                  name="remarks"
                >
                  <TextArea size="large" rows={4} placeholder="Enter remarks..." style={{ borderRadius: 8, resize: "none" }} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

export default CancelModel;
